document.addEventListener('alpine:init', () => {
  Alpine.data('productGallery', () => ({
    scrollableArea: null,
    init() {
      this.scrollableArea = this.$refs.scrollableArea;
      this.renderVerticalCssVars();
      this.handleVideoPlay();
    },
    render() {
      this.renderVerticalCssVars();
    },

    handleVideoPlay() {
      // Select both video elements
      const video1 = document.getElementById('product-gallery-video-desktop');
      const video2 = document.getElementById('product-gallery-video-mobile');

      // Create an array of the video elements to observe
      const videosToObserve = [];
      if (video1) videosToObserve.push(video1);
      if (video2) videosToObserve.push(video2);

      if (videosToObserve.length > 0) {
        const observerOptions = {
          threshold: 0.1,
        };

        const observerCallback = (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // Get the ID of the video that is currently in view
              const video = entry.target;

              const playPromise = video.play();

              if (playPromise !== undefined) {
                playPromise
                  .then(() => {
                    // Autoplay started!
                    console.log('Video is playing automatically.');
                    if (typeof clarity === 'function') {
                      clarity('set', 'video_viewed', video.dataset.productTitle);
                    }
                  })
                  .catch((error) => {
                    // Autoplay was prevented.
                    console.error('Autoplay was prevented. Reason:', error);
                  });
              }

              // Stop observing this specific video
              observer.unobserve(entry.target);
            }
          });
        };

        const videoObserver = new IntersectionObserver(observerCallback, observerOptions);

        // Tell the observer to start watching each video element in the array
        videosToObserve.forEach((video) => {
          videoObserver.observe(video);
        });
      }
    },
    renderVerticalCssVars() {
      const clientHeight = document.documentElement.clientHeight;
      const scrollHeight = this.scrollableArea.clientHeight;
      const rect = this.scrollableArea.getBoundingClientRect();
      let scrollTop = -1 * rect.top;

      if (scrollTop < 0) scrollTop = 0;
      if (scrollTop > scrollHeight) scrollTop = scrollHeight;

      // Set CSS variables for vertical scroll
      this.$el.style.setProperty('--product-gallery-vertical-shift', (100 * scrollTop) / scrollHeight + '%');

      const visibleTop = Math.max(rect.top, 0);
      const visibleHeight = Math.max(Math.min(clientHeight, rect.bottom), 0) - visibleTop;
      this.$el.style.setProperty('--product-gallery-vertical-height', (100 * visibleHeight) / scrollHeight + '%');

      // Toggle vertical-scrollable class if necessary
      if (clientHeight < scrollHeight) {
        this.$el.setAttribute('vertical-scrollable', true);
      } else {
        this.$el.removeAttribute('vertical-scrollable');
      }
    },
  }));
});
